{
  "name": "einsatzwetter-fe-v3",
  "version": "19.4.6+3",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --proxy-config src/proxy.conf.json",
    "build": "ng build",
    "test": "jest --no-cache --config ./jest.config.js",
    "test:watch": "jest --no-cache --watch --config ./jest.config.js",
    "test:coverage": "jest --no-cache --coverage --config ./jest.config.js",
    "lint": "ng lint --fix",
    "e2e": "ng e2e",
    "postinstall": "patch-package"
  },
  "private": true,
  "sideEffects": [
    "src/polyfills.ts"
  ],
  "dependencies": {
    "@angular-slider/ngx-slider": "^19.0.0",
    "@angular/animations": "^19.2.14",
    "@angular/cdk": "^19.2.19",
    "@angular/common": "^19.2.14",
    "@angular/compiler": "^19.2.14",
    "@angular/core": "^19.2.14",
    "@angular/elements": "^19.2.14",
    "@angular/forms": "^19.2.14",
    "@angular/material": "^19.2.19",
    "@angular/material-moment-adapter": "^19.2.19",
    "@angular/platform-browser": "^19.2.14",
    "@angular/platform-browser-dynamic": "^19.2.14",
    "@angular/router": "^19.2.14",
    "@aws-amplify/auth": "^5.1.9",
    "@aws-amplify/core": "^5.0.15",
    "@ctrl/ngx-csv": "^6.0.0",
    "@fortawesome/angular-fontawesome": "^1.0.0",
    "@fortawesome/fontawesome-pro": "^6.4.0",
    "@fortawesome/fontawesome-svg-core": "^6.4.0",
    "@fortawesome/pro-duotone-svg-icons": "^6.4.0",
    "@fortawesome/pro-light-svg-icons": "^6.4.0",
    "@fortawesome/pro-regular-svg-icons": "^6.4.0",
    "@fortawesome/pro-solid-svg-icons": "^6.4.0",
    "@jsverse/transloco": "^7.5.1",
    "@mapbox/mapbox-gl-geocoder": "^5.0.1",
    "@mapbox/mapbox-gl-language": "^1.0.1",
    "@ngneat/helipopper": "^11.1.3",
    "@ngx-translate/core": "^17.0.0",
    "@ngx-translate/http-loader": "^17.0.0",
    "@turf/bbox": "^6.5.0",
    "@turf/turf": "^7.3.4",
    "@wettermanufaktur-gmbh/ui-sdk": "^19.2.6",
    "d3": "^7.8.1",
    "d3-axis": "^3.0.0",
    "d3-scale": "^4.0.2",
    "d3-selection": "^3.0.0",
    "eslint-config-prettier": "^10.0.2",
    "eslint-plugin-prettier": "^5.2.3",
    "file-saver": "^2.0.5",
    "geojson": "^0.5.0",
    "highcharts": "^11.4.0",
    "highcharts-angular": "^4.0.0",
    "html2canvas": "^1.4.1",
    "jspdf": "^4.2.1",
    "jszip": "^3.7.0",
    "jszip-utils": "^0.1.0",
    "lodash": "^4.17.21",
    "mapbox-gl": "^3.13.0",
    "moment": "^2.29.1",
    "moment-timezone": "^0.5.32",
    "ng-mocks": "^14.13.2",
    "ngx-cookie-service": "^19.1.2",
    "ngx-mapbox-gl": "^12.0.0",
    "prettier-eslint": "^15.0.1",
    "raygun4js": "^3.1.3",
    "rxjs": "~7.8.0",
    "save-dev": "^0.0.1-security",
    "sunrise-sunset-js": "^2.2.1",
    "tslib": "^2.0.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^19.2.15",
    "@angular-eslint/builder": "17.5.2",
    "@angular-eslint/eslint-plugin": "17.5.2",
    "@angular-eslint/eslint-plugin-template": "17.5.2",
    "@angular-eslint/template-parser": "17.5.2",
    "@angular/cli": "^19.2.15",
    "@angular/compiler-cli": "^19.2.14",
    "@commitlint/cli": "^18.4.3",
    "@commitlint/config-conventional": "^18.4.3",
    "@types/geojson": "^7946.0.16",
    "@types/jest": "^29.5.14",
    "@types/lodash": "^4.14.194",
    "@types/node": "^12.11.1",
    "@types/raygun4js": "^3.0.0",
    "@typescript-eslint/eslint-plugin": "^7.2.0",
    "@typescript-eslint/parser": "^7.2.0",
    "eslint": "^8.57.0",
    "eslint-plugin-simple-import-sort": "^12.1.1",
    "eslint-plugin-unused-imports": "^4.1.4",
    "husky": "^9.1.7",
    "jest": "^29.7.0",
    "jest-preset-angular": "^14.6.0",
    "patch-package": "^8.0.1",
    "prettier": "3.5.3",
    "protractor": "~7.0.0",
    "ts-node": "~10.4.0",
    "typescript": "~5.8.3"
  },
  "resolutions": {
    "webpack": "5.4.0"
  },
  "browser": {
    "crypto": false,
    "stream": false
  }
}
